/**
 * Flight-time trickshot tiers (shared by single-player + multiplayer).
 * ≥3s Trickshot (2 pts) … ≥20s Impossible (19 pts), then the shot maxlen-ends.
 */

export type TrickshotTier =
  | 'none'
  | 'trickshot'
  | 'super'
  | 'mega'
  | 'ultra'
  | 'hyper'
  | 'extreme'
  | 'epic'
  | 'legendary'
  | 'mythic'
  | 'insane'
  | 'cosmic'
  | 'galactic'
  | 'stellar'
  | 'supreme'
  | 'ultimate'
  | 'transcendent'
  | 'godlike'
  | 'impossible';

/** Minimum flight seconds → tier + kill points. */
export const TRICKSHOT_TABLE: ReadonlyArray<{ minSec: number; tier: TrickshotTier; points: number; label: string }> = [
  { minSec: 20, tier: 'impossible', points: 19, label: 'IMPOSSIBLE TRICKSHOT!' },
  { minSec: 19, tier: 'godlike', points: 18, label: 'GODLIKE TRICKSHOT!' },
  { minSec: 18, tier: 'transcendent', points: 17, label: 'TRANSCENDENT TRICKSHOT!' },
  { minSec: 17, tier: 'ultimate', points: 16, label: 'ULTIMATE TRICKSHOT!' },
  { minSec: 16, tier: 'supreme', points: 15, label: 'SUPREME TRICKSHOT!' },
  { minSec: 15, tier: 'stellar', points: 14, label: 'STELLAR TRICKSHOT!' },
  { minSec: 14, tier: 'galactic', points: 13, label: 'GALACTIC TRICKSHOT!' },
  { minSec: 13, tier: 'cosmic', points: 12, label: 'COSMIC TRICKSHOT!' },
  { minSec: 12, tier: 'insane', points: 11, label: 'INSANE TRICKSHOT!' },
  { minSec: 11, tier: 'mythic', points: 10, label: 'MYTHIC TRICKSHOT!' },
  { minSec: 10, tier: 'legendary', points: 9, label: 'LEGENDARY TRICKSHOT!' },
  { minSec: 9, tier: 'epic', points: 8, label: 'EPIC TRICKSHOT!' },
  { minSec: 8, tier: 'extreme', points: 7, label: 'EXTREME TRICKSHOT!' },
  { minSec: 7, tier: 'hyper', points: 6, label: 'HYPER TRICKSHOT!' },
  { minSec: 6, tier: 'ultra', points: 5, label: 'ULTRA TRICKSHOT!' },
  { minSec: 5, tier: 'mega', points: 4, label: 'MEGA TRICKSHOT!' },
  { minSec: 4, tier: 'super', points: 3, label: 'SUPER TRICKSHOT!' },
  { minSec: 3, tier: 'trickshot', points: 2, label: 'TRICKSHOT!' },
];

/** Max flight time in seconds (Impossible window, then shot self-destructs). */
export const TRICKSHOT_MAX_FLIGHT_SEC = 20;

export function evaluateTrickshot(flightSec: number): {
  tier: TrickshotTier;
  points: number;
  label: string;
} {
  for (const row of TRICKSHOT_TABLE) {
    if (flightSec >= row.minSec) {
      return { tier: row.tier, points: row.points, label: row.label };
    }
  }
  return { tier: 'none', points: 1, label: '' };
}

export function trickshotLabel(tier: TrickshotTier): string {
  if (tier === 'none') return '';
  return TRICKSHOT_TABLE.find((r) => r.tier === tier)?.label ?? 'TRICKSHOT!';
}
